import React from 'react';
import { useLocation } from 'react-router-dom';
import { Hammer } from 'lucide-react';

const DemoComingSoon = () => {
  const { pathname } = useLocation();
  const section = pathname.replace('/dashboard/', '').replace(/-/g, ' ');

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-2xl bg-teal-50 text-teal-600">
        <Hammer size={28} strokeWidth={1.8} />
      </span>
      <h1 className="mt-5 text-[22px] font-bold capitalize">{section}</h1>
      <p className="mt-2 max-w-sm text-[14px] text-slate-500">
        This screen hasn't been built in the demo yet. It's coming as part of the UI overhaul.
      </p>
    </div>
  );
};

export default DemoComingSoon;
